var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper container"},[_c('h1',{staticClass:"page-header"},[_vm._v("Oops, this page does not exist...")]),_c('RouterLink',{staticClass:"btn border-btn",attrs:{"to":"/"}},[_vm._v("Back to Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }